<!-- Loading -->
<div class="fc-loading" *ngIf="!ready">
  <div class="fc-loading__dots"><span></span><span></span><span></span></div>
  <p>Cargando periodos…</p>
</div>

<div class="fc-page" *ngIf="ready">

  <!-- Cabecera -->
  <app-custom-table-title
    icon="lock"
    title="Cierre fiscal"
    [subTitle]="headerSubTitle"
    [actions]="headerActions">
  </app-custom-table-title>

  <!-- Aviso -->
  <div class="fc-notice">
    <mat-icon>warning</mat-icon>
    <span>
      El cierre de un período es <strong>irreversible</strong>. Una vez cerrado, no podrás registrar
      ni modificar movimientos en ese período.
    </span>
  </div>

  <!-- Filas de trimestres -->
  <div class="fc-quarters">

    <div class="fc-quarter-row" *ngFor="let q of quarters">

      <!-- Etiqueta trimestre -->
      <div class="fc-q-label">
        <span class="fc-q-badge">{{ q.label }}</span>
        <span class="fc-q-range">{{ q.range }}</span>
        <span class="fc-q-status-count" *ngIf="q.openUids.length > 0">
          {{ q.openUids.length }} abierto{{ q.openUids.length !== 1 ? 's' : '' }}
        </span>
        <span class="fc-q-status-count fc-q-status-count--closed" *ngIf="q.openUids.length === 0">
          Cerrado
        </span>
      </div>

      <!-- Meses -->
      <div class="fc-q-months">
        <div class="fc-q-month"
          *ngFor="let month of q.months"
          [class.fc-q-month--open]="month.estado === 'Abierto'"
          [class.fc-q-month--closed]="month.estado === 'Cerrado'"
          [class.fc-q-month--selected]="isSelected(month.uid)">

          <mat-checkbox
            *ngIf="month.estado === 'Abierto'"
            [checked]="isSelected(month.uid)"
            (change)="toggleSelect(month.uid)"
            color="primary">
          </mat-checkbox>
          <mat-icon class="fc-q-month__lock" *ngIf="month.estado === 'Cerrado'">lock</mat-icon>

          <div class="fc-q-month__info">
            <span class="fc-q-month__name">{{ month.mes }}</span>
            <span class="fc-badge"
              [class.fc-badge--open]="month.estado === 'Abierto'"
              [class.fc-badge--closed]="month.estado === 'Cerrado'">
              {{ month.estado }}
            </span>
          </div>

        </div>
      </div>

      <!-- Acción trimestre -->
      <div class="fc-q-action">
        <button mat-stroked-button class="fc-btn-danger fc-q-btn"
          *ngIf="q.openUids.length > 0"
          (click)="cierreQuarter(q.openUids)">
          <mat-icon>lock</mat-icon> Cerrar {{ q.label }}
        </button>
        <span class="fc-q-all-closed" *ngIf="q.openUids.length === 0">
          <mat-icon>check_circle</mat-icon>
        </span>
      </div>

    </div>

  </div>

</div>
